const URL_DOMAIN_REGEX = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)(\/)?/igm

export const extractThumbnailPath = (url = '') => {
    const extractedPath = url.split(URL_DOMAIN_REGEX).pop();
    if (url.startsWith('https://s3.amazonaws.com/')) {
        const bucketName = extractedPath.split('/')[0];
        return extractedPath.replace(`${bucketName}/`, '');
    }
    return extractedPath;
};



// WEBPACK FOOTER //
// ./src/utils/extractThumbnailPath.js